import * as React from 'react';
import { BaseRouteProps } from '../../interfaces';
import { PVAPage } from '../../components';
import { CharacteristicGroupForm } from './CharacteristicGroupForm';
import { CharacteristicGroupDataService } from '../../services';
import { CharacteristicGroup } from '../../models';
import { NavLink } from 'react-router-dom';

interface CharacteristicGroupCreateState {
    characteristicGroup: CharacteristicGroup;
}

export class CharacteristicGroupCreate extends React.Component<BaseRouteProps<{ id: number }>, CharacteristicGroupCreateState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{ id: number }>) {
        super(props);

        var cg = new CharacteristicGroup();
        cg.characteristicCompares = [];
        cg.characteristicGroupCharacteristics = [];
        cg.characteristicGroupTexts = [];

        this.state = {
            characteristicGroup: cg
        };
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.props.match.params.id + '/characteristicgroups'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">Create Characteristic Group</div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <CharacteristicGroupForm defaultValues={this.state.characteristicGroup} surveyVersionId={this.props.match.params.id} notificationService={this.props.notificationService} submit={(e: any) => this.save(e)} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.characteristicGroupDataService.create(values).then((success) => {
            this.props.history.push(`/characteristicgroup/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/characteristicgroup/CharacteristicGroupCreate.tsx